module.exports = __webpack_public_path__ + "static/media/property_300sc.f08532bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/climasense/cenicilla_pepino/curativa/property_300sc.png
// module id = 2098
// module chunks = 3